import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { PatchStockBody } from '@snootsvet/shared'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/**
 * Updates an existing stock row \u2014 quantity, batch number, or expiry date.
 * Admin override used by the per-product stock management page; bypasses the
 * stock_intake audit trail.
 */
export function usePatchStock() {
  const api = useOsApi()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, ...body }: PatchStockBody & { id: string }) => {
      const response = await api.patch('/stock/:id', { params: { id }, body })
      if (!response.success) throw new Error(response.error.message)
      return response.data
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['products'] })
      queryClient.invalidateQueries({ queryKey: ['product', data.stock.productId] })
    },
  })
}
